<template>
  <div class="full-width">
    <WBUDSwitchCell :cell="switchCell" :mIndex="mIndex" :namespace="namespace" />
    <v-text-field :ref="textCellKey" v-model="input[textCellKey]" :disabled="!switchVal" :label="$t(cell.textfieldTitle)" />
  </div>
</template>

<script>
import { getTitle } from './wb-common';
import WBUDSwitchCell from './WBUDSwitchCell.vue';

export default {
  components: { WBUDSwitchCell },
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  data: () => ({ getTitle }),
  computed: {
    switchCellKey() {
      return String(this.cell.key + this.mIndex);
    },
    textCellKey() {
      return String(this.cell.keyTextField + this.mIndex);
    },
    input: {
      get() {
        return this.$store.state[this.namespace].formInput;
      },
      set(val) {
        this.$store.state[this.namespace].formInput = val;
      },
    },
    switchVal() {
      return this.input[this.switchCellKey];
    },
    switchCell() {
      return {
        key: this.cell.key,
        title: this.cell.title,
        mandatory: this.cell.mandatory,
      };
    },
    textFieldCell() {
      return { mandatory: this.cell.mandatory, title: this.cell.textfieldTitle };
    },
  },
  created() {
    if (this.input[this.textCellKey] === undefined) {
      this.$set(this.input, this.textCellKey, '');
    }
  },
  watch: {
    switchVal(newVal) {
      if (!newVal) {
        this.$store.state[this.namespace].formInput[this.textCellKey] = '';
      } else {
        this.$nextTick(() => {
          this.$refs[this.textCellKey].focus();
        });
      }
    },
  },
};
</script>
